import clsx from "clsx"

type PublicationDateTimeLoaderProps = {
  readonly className?: string
}

export function PublicationDateTimeLoader({
  className,
}: PublicationDateTimeLoaderProps) {
  return (
    <div
      className={clsx(
        "inline-block h-[0.75em] w-5 animate-pulse bg-whisper motion-reduce:animate-none",
        className,
      )}
    />
  )
}
